import React, { useState, useContext } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Alert,
  Stack,
  MenuItem
} from '@mui/material';
import demoRequestApi from '../../api/demoRequestApi';
import { AuthContext } from '../../auth/AuthContext';
import BackButtonDesktop from '../../components/BackButtonDesktop';



export default function DemoRequestPage({ onSuccessRedirect }) {
  const { user } = useContext(AuthContext);
  const [form, setForm] = useState({
    nome: '',
    cognome: '',
    email: '',
    messaggio: '',
    prodotto: 'DeskStudio',
    profiloRichiesto: '',
  });
  const [err, setErr] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr(null);
    try {
      await demoRequestApi.create(form);
      setSuccess(true);
      if (onSuccessRedirect) {
        setTimeout(() => {
          window.location.href = onSuccessRedirect;
        }, 2000);
      }
    } catch (e) {
      setErr(e.response?.data || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Richiedi una Demo
      </Typography>
      {err && <Alert severity="error" sx={{ mb: 2 }}>{String(err)}</Alert>}
      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Richiesta inviata con successo!
        </Alert>
      )}
      {!success && (
        <form onSubmit={submit}>
          <Stack spacing={2}>
            <TextField
              label="Nome"
              name="nome"
              value={form.nome}
              onChange={handleChange}
              required
              fullWidth
            />
            <TextField
              label="Cognome"
              name="cognome"
              value={form.cognome}
              onChange={handleChange}
              required
              fullWidth
            />
            <TextField
              label="Email"
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              fullWidth
            />
            <TextField
              select
              fullWidth
              label="Profilo richiesto"
              value={form.profiloRichiesto}
              onChange={e => setForm({ ...form, profiloRichiesto: e.target.value })}
              sx={{ mb: 2 }}
            >
              {['CONTRIBUENTE','STUDIO'].map(m => (
                <MenuItem key={m} value={m}>{m}</MenuItem>
              ))}
            </TextField>
            <TextField
              label="Messaggio"
              type="messaggio"
              name="messaggio"
              value={form.messaggio}
              onChange={handleChange}
              fullWidth
            />
            <Button
              type="submit"
              variant="contained"
              sx={{ bgcolor: '#56C596', color: '#fff'}}
              disabled={loading}
            >
              {loading ? 'Invio...' : 'Invia Richiesta'}
            </Button>
            <BackButtonDesktop />

          </Stack>
        </form>
      )}
    </Container>
  );
}